<router-outlet></router-outlet>
<div class="container">
  <app-dashboard-header></app-dashboard-header>
  <div class="row">

    <app-dashboard-menu></app-dashboard-menu>

    <div class="graphics-area">
      <div class="top">
        <h4>Geral</h4>
        <div class="calendar-action">
          <button (click)="showModal()">
            <img src="../../assets/icons-prt/schedule.svg" alt="data">
            <span>{{todayDate | date: 'dd/MM'}} - Hoje</span>
          </button>
        </div>
      </div>
      <div class="content">
        <div class="col col-2">
          <div class="card card-dashboard-graphic">
            <div class="title">Volume de atendimento de leads</div>
            <div class="subtitle">Número de leads que foram distribuídos, atendidos e represados.</div>
            <div class="content">
              <canvas baseChart height="280" [labels]="barChartLabels" [datasets]="barChartDatasets"
                [options]="barChartOptions" [chartType]="barChartType">
              </canvas>
            </div>
          </div>
        </div>
        <div class="col col-2">
          <div class="card card-dashboard-graphic">
            <div class="title">Capacidade leads x corretores</div>
            <div class="subtitle">Capacidade de atendimento relativo ao número de corretores.</div>
            <div class="content">
              <canvas id="greenChart" baseChart height="250" [datasets]="doughnutChartData"
                [labels]="doughnutChartLabels" [options]="doughnutChartOptions" [chartType]="doughnutChartType"
                [plugins]="doughnutChartPlugins">
              </canvas>
              <span>Regra de <strong>3</strong> leads simultâneos, total de <strong>50</strong> corretores para
                <strong>240</strong> leads distribuídos.</span>
            </div>
          </div>
        </div>
      </div>
      <div class="management-area">
        <div class="col col-3">
          <a href="/fila-de-distribuicao">Gerenciar Filas &#10132;</a>
          <div class="card card-management-data">
            <div class="positive">
              <div class="title">Filas de Distribuição Ativas</div>
              <div class="number">3</div>
            </div>
            <div class="negative">
              <div class="title">Inativas</div>
              <div class="number">0</div>
            </div>
          </div>
        </div>
        <div class="col col-3">
          <a href="">Gerenciar Corretores &#10132;</a>
          <div class="card card-management-data">
            <div class="positive">
              <div class="title">Corretores Online</div>
              <div class="number">34</div>
            </div>
            <div class="negative">
              <div class="title">Offline</div>
              <div class="number">78</div>
            </div>
          </div>
        </div>
        <div class="col col-3">
          <a href="">Gerenciar Leads &#10132;</a>
          <div class="card card-management-data">
            <div class="positive">
              <div class="title">Leads Recebidos</div>
              <div class="number">45</div>
            </div>
            <div class="negative">
              <div class="title">Represados</div>
              <div class="number">19</div>
            </div>
          </div>
        </div>
      </div>

      <table class="table-queue" cellspacing="0">
        <tr>
          <th width="30%">Filas</th>
          <th>Distribuídos</th>
          <th>Não Atendidos</th>
          <th>Represados</th>
          <th>Corretores</th>
        </tr>
        <tr>
          <td>Campanha do Facebook de Fevereiro</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
        </tr>
        <tr>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
        </tr>
      </table>
    </div>

  </div>
</div>
<nz-modal class="modal-dashboard" [(nzVisible)]="isVisible" nzTitle="Visualização de relatórios por data" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
  <div class="modal-content">
    <div class="select-period">
      <strong>Período:</strong>
      <nz-select [(ngModel)]="periodType" ngModel="personalized" ngDefaultControl>
        <nz-option nzValue="personalized" nzLabel="Personalizado"></nz-option>
        <nz-option nzValue="yesterday" nzLabel="Ontem"></nz-option>
        <nz-option nzValue="lastWeek" nzLabel="Semana Passada"></nz-option>
        <nz-option nzValue="lastMonth" nzLabel="Mês Passada"></nz-option>
        <nz-option nzValue="last7days" nzLabel="Últimos 7 dias"></nz-option>
        <nz-option nzValue="last30days" nzLabel="Últimos 30 dias"></nz-option>
      </nz-select>
    </div>
    <nz-range-picker 
      *ngIf="periodType == 'personalized'" 
      class="datepicker-range" 
      [(ngModel)]="date" 
      ngDefaultControl
      (ngModelChange)="onChange($event)"
      [nzFormat]="'dd MMM yyyy'">
    </nz-range-picker>
  </div>
  <div *nzModalFooter>
    <button class="btn-base btn-outline-lopes" (click)="handleCancel()">Cancelar</button>
    <button class="btn-base btn-lopes" (click)="handleOk()">Aplicar</button>
  </div>
</nz-modal>